<template>
  <div id="notfound">
    <div class="container centered">
        <img src="../../assets/logo-transparent.png">
        <h1 class="title is-1"> 404 </h1>
        <h2 class="subtitle is-3"> Страница не найдена </h2>
        <p> Перейдите <a v-on:click="goHome"> на главную </a> </p>
    </div>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  export default {
    name: 'notfound',
    methods: {
      goHome() {
        this.$router.push(config.WELCOME_URL)
      }
    }
  }
</script>

<style>
  .centered {
    margin-top: 5%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/notfound.vue